// extracted by mini-css-extract-plugin
export default {"infologCollapse":"wagon-services_infologCollapse__cYL7w"};